import React from 'react';
import {useField} from 'formik';

import InstitutionTypeaheadWithModal from 'shared/institution-typeahead/components/institution-typeahead-with-modal';
import {Props as InstitutionTypeaheadProps} from 'shared/institution-typeahead/components/institution-typeahead';
import {CourseForm} from './course-form-wrapper';

interface Props {
  name?: string;
  prefix?: string;
}

const InstitutionTypeahead = ({
  name = 'institution',
  prefix = '',
  ...props
}: Props & Partial<InstitutionTypeaheadProps>) => {
  const [courseTypeField] = useField<CourseForm['courseType']>(`${prefix}courseType`);

  return (
    <InstitutionTypeaheadWithModal
      institutionType={
        courseTypeField.value === 'Dual Enrollment' ? 'dual-enrollment' : 'high-school'
      }
      fieldName={name}
      renderLabel={({type}) =>
        type === 'high-school'
          ? 'At what high school did you take this course?'
          : 'With which college did you take this course?'
      }
      {...props}
    />
  );
};

export default InstitutionTypeahead;
